import { 
  signInWithPopup, 
  GoogleAuthProvider, 
  signOut as firebaseSignOut 
} from 'firebase/auth';
import { auth } from '../firebase';

const googleProvider = new GoogleAuthProvider();

// Configure Google provider
googleProvider.addScope('email');
googleProvider.addScope('profile');

export const authService = {
  // Sign in with Google
  async signInWithGoogle() {
    try {
      const result = await signInWithPopup(auth, googleProvider);
      
      // This gives you a Google Access Token. You can use it to access the Google API.
      const credential = GoogleAuthProvider.credentialFromResult(result);
      const token = credential?.accessToken;
      
      // The signed-in user info
      const user = result.user;
      
      // console.log('Google sign-in successful:', user.uid);
      return { user, token };
    } catch (error) {
      console.error('Google sign-in error:', error);
      
      // Handle specific error codes
      let errorMessage = 'Failed to sign in with Google';
      
      switch (error.code) {
        case 'auth/popup-closed-by-user':
          errorMessage = 'Sign-in was cancelled';
          break;
        case 'auth/popup-blocked':
          errorMessage = 'Sign-in popup was blocked. Please allow popups and try again';
          break;
        case 'auth/cancelled-popup-request':
          errorMessage = 'Only one sign-in popup is allowed at a time';
          break;
        case 'auth/network-request-failed':
          errorMessage = 'Network error. Please check your connection and try again';
          break;
        default:
          errorMessage = error.message || 'Failed to sign in with Google';
      }
      
      throw new Error(errorMessage);
    }
  },

  // Sign out
  async signOut() {
    try {
      await firebaseSignOut(auth);
      // console.log('User signed out successfully');
    } catch (error) {
      console.error('Sign-out error:', error);
      throw new Error('Failed to sign out');
    }
  },

  // Get current user
  getCurrentUser() {
    return auth.currentUser;
  }
};
